export default __webpack_public_path__ + "static/logo_alt.ea892d643e11f33175d1930b8ccc8e5d.png";